module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-SemiCnIt.738b4b4.woff";